<template>
  <div class="flex flex-col gap-2.5">
    <div
      class="flex items-center justify-center p-3.75 text-center bg-main-background rounded-[15px]"
    >
      <div class="flex flex-col gap-3.75 flex-1 w-full">
        <h3 class="text-center text-balance" :class="$typo.openSansBold14">
          {{ emptyHeader && !filtersActive ? emptyHeader : header }}
        </h3>
      </div>
    </div>
    <div
      class="flex items-center justify-center p-3.75 gap-2 text-center bg-main-background rounded-[15px]"
      @click="onDescriptionClick"
    >
      <p :class="[$typo.openSans12]" class="text-text-muted text-left flex-1">
        {{ emptyDescription && !filtersActive ? emptyDescription : description }}
      </p>
      <IconCustom class="text-text-inactive" :ligature="icon" :size="'36'"></IconCustom>
    </div>
    <div
      v-if="filtersActive"
      class="flex items-center justify-center p-3.75 gap-2.5 text-center bg-main-background rounded-[15px]"
      @click="resetFilters"
    >
      <p :class="[$typo.openSans12]" class="text-text-muted text-left flex-1">
        {{ t('noItemsFoundResetFilter') }}
      </p>
      <IconCustom class="text-text-inactive" ligature="rotate_ccw" :size="'36'"></IconCustom>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import $typo from '@/styles/typografy.module.css'
import IconCustom from '@/components/IconCustom.vue'
import { useRouter } from 'vue-router'
import { RouteName } from '@/router'
import { useLocalizationStore } from '@/stores/localization.ts'
import { useUiStore } from '@/stores/ui.store.ts'
import type { IconName } from '@/icons'

const props = defineProps<{
  header: string
  emptyHeader?: string
  description: string
  emptyDescription?: string
  emptyDescriptionRoute?: 'overview'
  icon: IconName
}>()

const router = useRouter()
const { t } = useLocalizationStore()
const uiStore = useUiStore()
const { filtersActive, currentFilter } = storeToRefs(uiStore)
const { resetFilters, setPendingDatabaseFilter } = uiStore

const showingEmptyDescription = computed(() => !!props.emptyDescription && !filtersActive.value)

function onDescriptionClick() {
  if (showingEmptyDescription.value && props.emptyDescriptionRoute === 'overview') {
    router.push({ name: RouteName.Overview })
    return
  }
  goToDatabase()
}

function goToDatabase() {
  if (currentFilter.value) {
    const { selectedMedium, selectedPublisher, selectedTags, seriesTitle } = currentFilter.value
    const hasValues =
      selectedMedium?.length > 0 ||
      selectedPublisher?.length > 0 ||
      selectedTags?.length > 0 ||
      seriesTitle?.length > 0

    if (hasValues) {
      setPendingDatabaseFilter({ selectedMedium, selectedPublisher, selectedTags, seriesTitle })
      router.push({ name: RouteName.Exploration })
      return
    }
  }
  router.push({ name: RouteName.Exploration, query: { search: 'true' } })
}
</script>
